// eslint-disable-next-line import/no-anonymous-default-export
export default {
  loading: false,
  error: false,
  loginStatus: {
    data: null,
  },
  getMovementlistStatus: { data: null },
  createMovementStatus: { data: null },
  editMovementStatus: { data: null },
  deleteMovementStatus: { data: null },
};
